export default "__VITE_ASSET__CkLObbST__"